import { render, staticRenderFns } from "./RequestedDocumentTypeFormDialog.vue?vue&type=template&id=cff31e3c&"
import script from "./RequestedDocumentTypeFormDialog.vue?vue&type=script&lang=js&"
export * from "./RequestedDocumentTypeFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports